




















import Vue from 'vue'
import MainArea from '@/components/MainArea.vue'
import ImageArea from '@/components/ImageArea.vue'

import Store from '@/services/Store'

export default Vue.extend({
  name: "QuizQuestion",
  props: {
    selectedAnswer: String
  },
  methods: {
    // Display helper methods

    getCurrentQuestionImage(){ return Store.quizState.getCurrentQuestionImage() },
    getCurrentQuestionText(){ return Store.quizState.getCurrentQuestionText() },
    getCurrentQuestionAudio(){ return Store.quizState.getCurrentQuestionAudio() },
    getCurrentOptions(){ return Store.quizState.getCurrentOptions() },

    buttonStatus(answer: string){
      // Return status only for the currently selected answer:
      if(this.selectedAnswer != answer) return ""
      return this._isAnswerCorrect(answer) ? "correct" : "wrong"
    },

    // Handlers

    handleAnswerClick(answer: string){
      this.$router.push({ name: 'QuizFeedback', params: { selectedAnswer: answer } })
    },

    // Methods not used in the template

    _isAnswerCorrect(answer: string){ 
      return Store.quizState.getCorrectAnswers().includes(answer)
    }
  },
  components: {
    MainArea, ImageArea
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.quiz != "play") next({ name: 'QuizIntro' }) 
    else next()
  }
})
